import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS, FEATURE_FLAGS, ALL_LANGUAGE_ENUM } from "../../../../constants/Define";
import { Link } from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import GroupCategory from './../../../../models/GroupCategory';
import { Icon, Rate } from 'antd';
import GroupCategoryList from './GroupCategoryList';
import moment from 'moment'
import { omit, orderBy } from 'lodash'
import Ripple from '../../common/component/Ripple';
import { getContentLanguage } from '../../../../utils/commonUtils';

let permissionActions = [];
export default class GroupCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.GROUP_CATEGORY);
        this.getGroupCategories();
        this.props.getAllGroupCategories({ withoutChildren: true });
    }

    render() {
        const { t, groupCategoryState } = this.props;
        const { filters } = this.state;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, groupCategories, allGroupCategories } = groupCategoryState;
        const pagination = { totalCount, totalPage, pageIndex, pageSize };
        const categoryData = filters.languageCode ? this.filterCategory(groupCategories, filters) : groupCategories;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vouchers'}
                        titleHeader={t('navigation.groupCategories')}
                        componentRight={
                            <Fragment>{
                                permissionActions && permissionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.GROUP_CATEGORY.CREATE.path}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <GroupCategoryList loading={isFetching}
                        permissions={permissionActions}
                        categories={categoryData}
                        parents={allGroupCategories}
                        pagination={pagination}
                        onTableChange={this.onTableChange}
                        onDeleteGroupCategory={this.onDeleteGroupCategory}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        const { groupCategoryState } = this.props;
        const { groupCategoriesBackup } = groupCategoryState;
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        let result = orderBy(groupCategoriesBackup, [newFilters.OrderBy], [newFilters.OrderByDesc ? 'desc' : 'asc'])
        result = this.filterCategory(result, newFilters);
        this.props.setGroupCategories({ result, ...newFilters });
    };

    filterCategory = (groupCategorys = [], filters = {}) => {
        const result = [];
        groupCategorys.forEach((item, index) => {
            let check = true;
            if (filters.parentId && item.parentId !== filters.parentId) {
                check = false;
            }
            if (filters.languageCode && item.translations.findIndex(i => i.languageCode === filters.languageCode) === -1) {
                check = false;
            }
            if (filters.name && Func.vietnameseStringToUnicode(item.name.toLowerCase()).indexOf(Func.vietnameseStringToUnicode(filters.name.toLowerCase())) === -1) {
                return false;
            }
            if (check && item.children && item.children.length) {
                item.children = this.filterCategory(item.children, filters);
            }
            if (check) {
                result.push(item);
            }
        })
        return result;
    }

    getGroupCategories(filters) {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getGroupCategories(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { groupCategoryState } = this.props;
        const filters = omit(groupCategoryState, ['groupCategories', 'detail', 'allGroupCategories', 'isFetching', 'isFetchingUpdate', 'isFetchingDetail', 'isFetchingTranslate']);
        const globalLanguageCode = getContentLanguage();
        if (globalLanguageCode !== ALL_LANGUAGE_ENUM) {
            filters.languageCode = globalLanguageCode;
        }
        return removeFields ? omit(filters, removeFields) : filters;
    }

    onDeleteGroupCategory = (groupCategory) => {
        this.props.deleteGroupCategory(groupCategory, this.state.filters)
    }

    onChangeLanguage = (language) => {
        const { groupCategoryState } = this.props;
        const { groupCategoriesBackup } = groupCategoryState;
        const newFilters = this.state.filters;
        newFilters.languageCode = language !== ALL_LANGUAGE_ENUM && language;
        let result = orderBy(groupCategoriesBackup, [newFilters.OrderBy], [newFilters.OrderByDesc ? 'desc' : 'asc'])
        result = this.filterCategory(result, newFilters);
        this.props.setGroupCategories({ result, ...newFilters });
    }


}

GroupCategories.defaultProps = {

}
